export function getPlotPublicNumber(displayNumber: string) {
  return displayNumber.replace(/^№\s*/u, '');
}
